import styled from "styled-components";

import { fonts } from "styles";

export const Container = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: black;
  position: relative;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 375px) {
    align-items: flex-start;
    padding-top: 72px;
    height: 100%;
    overflow-y: auto;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 474px;
  display: flex;
  flex-direction: column;
  padding: 0 40px;

  @media screen and (max-width: 414px) {
    padding: 0 24px;
  }
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansWideMedium};
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 72px;
  color: white;
  text-transform: uppercase;

  @media screen and (max-width: 414px) {
    font-size: 15px;
    line-height: 20px;
    margin-bottom: 32px;
  }
`;
